type VideoProvider = 'youtube' | 'loom';

interface VideoEmbedProps {
  provider: VideoProvider;
  videoId: string;
  title?: string;
}

function buildEmbedUrl(provider: VideoProvider, videoId: string): string {
  if (provider === 'youtube') {
    return `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1`;
  }
  return `https://www.loom.com/embed/${videoId}?hide_owner=true&hide_share=true&hide_title=true`;
}

export function VideoEmbed({ provider, videoId, title }: VideoEmbedProps) {
  const isEmpty = !videoId || videoId === 'PLACEHOLDER';

  return (
    <div className="relative w-full aspect-video rounded-2xl overflow-hidden shadow-lg">
      {isEmpty ? (
        <div className="absolute inset-0 bg-muted flex items-center justify-center">
          <span className="text-muted-foreground text-sm font-medium">Video in arrivo</span>
        </div>
      ) : (
        <iframe
          src={buildEmbedUrl(provider, videoId)}
          title={title ?? 'Video'}
          className="absolute inset-0 w-full h-full"
          loading="lazy"
          allowFullScreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        />
      )}
    </div>
  );
}
